module.exports = __webpack_public_path__ + "static/media/greenCheck.e4efba94.svg";